import { createRouter, createWebHistory } from 'vue-router';
import Login from '../components/Login.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../components/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    props: (route) => ({ otpMessage: route.query.otpMessage || '' })
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../components/About.vue')
  },
  {
    path: '/engineering',
    name: 'Engineering',
    component: () => import('../components/Engineering.vue')
  },
  {
    path: '/community',
    name: 'Community',
    component: () => import('../components/Community.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../components/Register.vue')
  },
  {
    path: '/sc-member-dashboard',
    name: 'SCMemberDashboard',
    component: () => import('../components/SCMemberDashboard.vue')
  },
  {
    path: '/borrow',
    name: 'Borrow',
    component: () => import('../components/Borrow.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../components/Dashboard.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Navigation guard to check authentication
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const protectedRoutes = ['Dashboard', 'SCMemberDashboard', 'Borrow'];
  
  if (protectedRoutes.includes(to.name) && !token) {
    next({ name: 'Login' });
  } else {
    next();
  }
});

export default router;

